<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9XzJa3/tc-custom/9780374302535.jpg?1728726194186" alt="This image is the cover for the book Balcony on the Moon"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Balcony on the Moon
      </h1>
      <p class="bookDescription body article font2">
        <b>“Endearing . . . lyrical . . . depicts an adolescence that will be simultaneously familiar to readers . . . and very different in its backdrop of 1970s Palestine.” —<i>School Library Journal</i></b><br/><br/>A Junior Library Guild Selection<br/><br/>A Palestine Book Award Shortlist Selection<br/><br/>A VOYA Nonfiction Honor Roll Selection<br/><br/>A Skipping Stones Honor Book<br/><br/>An Arab-American National Museum Honor Book<br/><br/>A Bank Street College of Education Best Book<br/><br/>An American Library Association/Amelia Bloomer Project Top Ten Book<br/><br/>A Notable Book for a Global Society<br/><br/>A News &amp; Observer Newspaper’s Wilde Best Book Award Winner<br/><br/>A Middle East Book Award Honorable Mention<br/><br/>Picking up where her award-winning first memoir, <i>Tasting the Sky</i> left off, <i>Balcony on the Moon</i> follows Ibtisam Barakat through her childhood and adolescence in Palestine from 1972-1981 and chronicles her desire to be a writer. A young Ibtisam finds inspiration through writing letters to pen pals and from an adult who encourages her to keep at it, but the most surprising turn of all for Ibtisam happens when her mother decides that she would like to seek out an education, too. This memoir is a touching, at times funny, and enlightening look at the not often depicted daily life in a politically tumultuous area.<br/><br/>“Lyrical and moving, Barakat’s first-person, present-tense story catapults the reader into a time when political tensions and the battle for human rights rage on, and the fight, not only for survival, but to have a voice is in full swing. Not to be missed, this memoir is a wonderful additional to any library.” —<i>VOYA</i>, starred review<br/><br/>“A compelling personal history, brimming with humor, wisdom, and empathy.” —<i>Publishers Weekly</i>, starred review<br/><br/>“A poetic, deeply felt coming-of-age story.” —<i>Kirkus Reviews</i>, starred review<br/><br/>“As inspiring as it is engrossing.” —<i>Booklist</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ibtisam Barakat
      </h2>
      
      <p class="authorDescription body article">Ibtisam Barakat is the author of TASTING THE SKY: A PALESTINIAN CHILDHOOD. She grew up in Palestine and is an educator, poet, and peace activist. She lives in Columbia, Missouri.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5bfae349